// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14pYU","type":"styles_type__2ZRVh","choices":"styles_choices__4sNjv"};